import { NavLink, Outlet } from "react-router-dom";
import { Briefcase, Receipt, CalendarOff, User } from "lucide-react";
import { cn } from "@/lib/utils";
import api from "@/api";
import ForcePasswordGate from "@/components/ForcePasswordGate";
import AttendanceWidget from "@/components/AttendanceWidget";

const TABS = [
  { to: "/app", end: true, label: "Jobs", icon: Briefcase },
  { to: "/app/expenses", label: "Expenses", icon: Receipt },
  { to: "/app/leaves", label: "Leaves", icon: CalendarOff },
  { to: "/app/profile", label: "Profile", icon: User },
];

export default function EmpLayout() {
  const impersonating = sessionStorage.getItem("cm_impersonating");
  const exitImpersonation = async () => {
    try { await api.post("/auth/impersonate-exit"); } catch (e) { console.warn("impersonation exit failed", e); }
    sessionStorage.removeItem("cm_impersonating");
    window.location.href = "/admin/users";
  };
  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="emp-layout">
      <div className="max-w-md mx-auto min-h-screen flex flex-col border-x border-border">
        {impersonating && (
          <div className="bg-warning text-warning-foreground text-xs font-semibold px-4 py-2.5 flex items-center justify-between" data-testid="emp-impersonation-banner">
            <span>Viewing as {impersonating}</span>
            <button onClick={exitImpersonation} className="underline font-bold" data-testid="emp-exit-impersonation">Exit</button>
          </div>
        )}
        <header className="sticky top-0 z-30 flex min-h-12 items-center justify-end border-b border-border bg-background px-4 py-2">
          <AttendanceWidget variant="dark" />
        </header>
        <div className="flex-1 overflow-y-auto pb-24">
          <Outlet />
        </div>
        <ForcePasswordGate />
        <nav className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md bg-surface border-t border-border grid grid-cols-4 z-40" data-testid="emp-bottom-nav">
          {TABS.map((t) => (
            <NavLink key={t.to} to={t.to} end={t.end} data-testid={`emp-tab-${t.label.toLowerCase()}`}
              className={({ isActive }) => cn(
                "flex flex-col items-center gap-1 py-3 text-[11px] font-medium transition-colors",
                isActive ? "text-success" : "text-muted-foreground"
              )}>
              <t.icon size={22} /> {t.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </div>
  );
}
